import axios from 'axios'
import {
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
import {
  getToken
} from '@/utils/auth'
import {toLogin} from '@/utils'
// import { duration } from 'moment'
// import { Loading } from 'element-ui';
// import { rsort } from 'semver'

const baseURL = 'https://www.zhiwubang.cn:8080/'
// const baseURL = 'http://123.57.66.225:81/api/'
// const baseURL = 'http://localhost:8080/'
//const baseURL = 'http://192.168.110.73:8080'


// create an axios instance
const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 80000 // request timeout
})

//请求发送拦截
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
       config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//请求响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data  || response.page;
    if (res.code && res.code !== 0) {
      if (res.code == 401) {
        // MessageBox.confirm('当前token已失效,请重新登录', {
        //   showClose: false,
        //   showCancelButton: false,
        //   closeOnClickModal: false,
        //   closeOnPressEscape: false,
        //   confirmButtonText: '去登录',
        //   type: 'warning'
        // }).then(() => {
        //   toLogin()
        // })
        toLogin()
      } else {
        if (res.msg != "未知异常，请联系管理员") {
           Message({
            message: res.msg || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
        }

      }
      //return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    const errorCode = error.toString().replace(/[^0-9]/ig, "");
    if (errorCode == 401) {
      localStorage.clear();
      sessionStorage.clear();
      MessageBox.confirm('当前token已失效,请重新登录', {
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: '去登录',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      })
    } else {
		if(error.toString().indexOf('Error: Network Error') >-1){
		   return  false;
		}else{
		  Message({
			  message: error,
			  type: 'error',
			  duration: 5 * 1000
		  });
		}
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js